import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './Front/App';
import Auth from './auth';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {
      <Auth />
    }
  </React.StrictMode>
);